































































































































































































































import { computed, defineComponent, PropType } from '@vue/composition-api';
import { GroupStats } from '@front-app/services/GroupsApi/GroupModel';
import { GroupsStore } from '@front-app/store/singletons/Groups';
import { GroupStatsStore } from '@front-app/store/singletons/GroupStats';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import LoaderState from '@front-app/components/LoaderState.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';

export default defineComponent({
	components: {
		FontAwesomeIcon,
		CtaButton,
		LoaderState,
	},
	props: {
		checkedGroupIds: {
			type: Array as PropType<string[]>,
			default: [],
		},
		areAnyCheckedGroupsDiscussable: {
			type: Boolean,
		},
		isLoading: {
			type: Boolean,
		},
		hasAdministerableGroups: {
			type: Boolean,
		},
	},
	setup(props) {
		const isFetchingNewStats = computed(() => {
			if (!props.isLoading) {
				return false;
			}
			return !props.checkedGroupIds.every((id) => Boolean(GroupStatsStore.getInstance().stats.value[id]));
		});
		const groupStats = computed(() => props.checkedGroupIds
			.map((id) => GroupStatsStore.getInstance().stats.value[id])
			.filter((_) => Boolean(_))
			.reduce((allStats, stats) => ({
				numDiscussions: allStats.numDiscussions + stats.numDiscussions,
				numDiscussionPosts: allStats.numDiscussionPosts + stats.numDiscussionPosts,
				numActiveMembers: allStats.numActiveMembers + stats.numActiveMembers,
				numInviteesInternal: allStats.numInviteesInternal + stats.numInviteesInternal,
				numInviteesExternal: allStats.numInviteesExternal + stats.numInviteesExternal,
				numSharedItems: allStats.numSharedItems + stats.numSharedItems || 0,
				numCategories: allStats.numCategories
					+ (GroupsStore.getInstance().groupById(stats.id)?.categories.length || 0),
				numActiveEvents: allStats.numActiveEvents + stats.numActiveEvents,
				numPastEvents: allStats.numPastEvents + stats.numPastEvents,
				numFutureEvents: allStats.numFutureEvents + stats.numFutureEvents,
			}), getEmptyStats()));
		return {
			ButtonPalettes,
			groupStats,
			isFetchingNewStats,
			getGroupName: (id: string) => GroupsStore.getInstance().groupById(id)?.name,
		};
	},
});

interface CumulativeStats extends Omit<GroupStats, 'id'> {
	numCategories: number;
}

function getEmptyStats(): CumulativeStats {
	return {
		numDiscussions: 0,
		numDiscussionPosts: 0,
		numActiveMembers: 0,
		numInviteesInternal: 0,
		numInviteesExternal: 0,
		numSharedItems: 0,
		numCategories: 0,
		numActiveEvents: 0,
		numPastEvents: 0,
		numFutureEvents: 0,
	};
}
